import React from "react";

const CloseIconMb = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<circle cx="16" cy="16" r="16" fill="none"/>
<path d="M23.1615 8.55078L8.7373 22.975" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8.7373 8.55078L23.1615 22.975" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  );
};
export default CloseIconMb;

export const CloseIconRounded = (props) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.1213 10.1213L5.87868 5.87868M5.87868 10.1213L10.1213 5.87868M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z" stroke="#1C274C" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
};